import { render } from "./call.vue?vue&type=template&id=54448bf2&scoped=true&ts=true"
import script from "./call.vue?vue&type=script&lang=ts"
export * from "./call.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=54448bf2&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54448bf2"]])

export default __exports__